<template>
  <div
    class="favorites__product product"
    v-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true"
  >
    <router-link
      v-if="this.detail.id"
      :to="{ name: 'ProductDetail', params: { id: this.detail.id } }"
      class="product__image-container"
    >
      <img
        class="product__image"
        alt=""
        v-if="this.detail && this.detail.photos[0]"
        :src="imagesurl + '600/' + this.detail.photos[0].name"
      />
      <img v-else class="product__image" src="/static/img/600x400.jpg" alt="" />
    </router-link>
    <div class="product__info-container">
      <div class="product__info-main">
        <div class="product__name-container">
          <h3 class="product__name">{{ this.detail.label }} {{ this.detail.id }}</h3>
        </div>
        <p class="product__code">Code article : {{ this.detail.code }}</p>
      </div>
      <div class="product__stock-container">
        <span class="stock__text">Etat du stock</span>
        <div class="product__stock stock">
          <div
            v-if="
              this.detail.vehicleStocks &&
              this.detail.vehicleStocks[0] &&
              this.detail.vehicleStocks[0].stock < this.detail.vehicleStocks[0].min_stock
            "
            class="stock__picto red"
          >
            <img src="/static/img/pictos/camionstockssbulle.svg" alt="" />
          </div>
          <div
            v-else-if="
              this.detail.vehicleStocks &&
              this.detail.vehicleStocks[0] &&
              this.detail.vehicleStocks[0].stock == this.detail.vehicleStocks[0].min_stock
            "
            class="stock__picto orange"
          >
            <img src="/static/img/pictos/camionstockssbulle.svg" alt="" />
          </div>
          <div
            v-else-if="this.detail.vehicleStocks && this.detail.vehicleStocks[0]"
            class="stock__picto green"
          >
            <img src="/static/img/pictos/camionstockssbulle.svg" alt="" />
          </div>
          <span
            class="stock__number"
            v-if="this.detail.vehicleStocks && this.detail.vehicleStocks[0]"
            >{{ this.detail.vehicleStocks[0].stock }}</span
          >

          <div
            v-if="
              this.detail.productShops &&
              this.detail.productShops[0] &&
              this.detail.productShops[0].stock == 0
            "
            class="stock__picto magasin rouge"
          >
            <img src="/static/img/pictos/magasinstockssbulle.svg" alt="" />
          </div>
          <div
            v-else-if="
              this.detail.productShops &&
              this.detail.productShops[0] &&
              this.detail.productShops[0].stock <= 10
            "
            class="stock__picto magasin orange"
          >
            <img src="/static/img/pictos/magasinstockssbulle.svg" alt="" />
          </div>
          <div
            v-else-if="this.detail.productShops && this.detail.productShops[0]"
            class="stock__picto magasin green"
          >
            <img src="/static/img/pictos/magasinstockssbulle.svg" alt="" />
          </div>
          <span
            class="stock__number"
            v-if="this.detail.productShops && this.detail.productShops[0]"
            >{{ this.detail.productShops[0].stock }}</span
          >
        </div>
      </div>
    </div>
    <div class="product__btns">
      <router-link
        v-if="this.detail.id"
        :to="{ name: 'ProductDetail', params: { id: this.detail.id } }"
        class="product__btn product__btn--see"
      >
        <img src="/static/img/pictos/flecheblanche.svg" alt="" />
      </router-link>
      <ProductAddToCart :item="this.detail"></ProductAddToCart>
    </div>
  </div>
  <Product v-else :item="this.detail" :class="'product--fullwidth product--no-border'"></Product>
</template>

<script>
import ProductAddToCart from "@/components/Product/ProductAddToCart";
import Product from "@/components/Product/Product";

export default {
  name: "ProductFavorites",
  props: ["id"],
  data() {
    return {
      detail: {},
    };
  },
  methods: {},
  components: {
    ProductAddToCart,
    Product,
  },
  created() {
    const self = this;
    this.detail = this.$store.getters["product/getItemCurrent"](self.id);
  },
  computed: {
    imagesurl() {
      return process.env.BACK_UPLOADS_URL;
    },
  },
  mounted() {},
};
</script>


<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

.product {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  position: relative;
  background-color: white;
  width: 100%;
  height: 210px;
  border: 1px solid $grisclair;
  margin-bottom: 60px;
  &__image-container {
    width: 50%;
    height: 100%;
  }
  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &__info-container {
    width: 50%;
    height: 100%;
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: stretch;
  }
  &__info-main {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;
    align-items: top;
    flex: 1;
    padding: 15px;
    .product__name-container {
      width: 100%;
      line-height: 1;
    }
  }
  &__name {
    font-size: 15px;
    text-transform: uppercase;
    font-family: "ClanFFBlack";
    color: $mystockblue;
  }
  &__code {
    font-size: 12px;
    color: $grisfonce;
    font-family: "ClanPro";
    margin-bottom: 0;
  }
  &__btns {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-start;
    width: 100%;
    position: absolute;
    bottom: -40px;
    left: 0;
  }
  &__stock-container {
    border: 1px solid $color1;
    padding: 15px;
    height: 95px;
  }
  .stock {
    width: 100%;
    text-transform: uppercase;
    font-family: "ClanPro";
    color: $grisfonce;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;
    &__picto {
      width: 30px;
      margin-left: 20px;
      position: relative;
      img {
        width: 100%;
      }
      &.magasin {
        img {
          width: 25px;
        }
      }
      &:before {
        content: "";
        display: block;
        width: 24px;
        height: 24px;
        opacity: 0.75;
        position: absolute;
        top: 0;
        left: 0;
        margin-left: -10px;
        margin-top: -10px;
        border-radius: 50%;
      }
      &.green {
        &:before {
          background: $vert;
        }
      }
      &.red {
        &:before {
          background: $rouge;
        }
      }
      &.orange {
        &:before {
          background: $orange;
        }
      }
    }
    &__text {
      margin: 0 10px;
      font-family: "ClanPro";
      color: $color1;
      font-size: 12px;
      margin-bottom: 15px;
      display: block;
      text-transform: uppercase;
    }
    &__number {
      text-align: center;
      margin: 0 10px;
      font-family: "ClanFFBlack";
      color: $grisfonce;
      font-size: 16px;
      display: block;
    }
  }
  &__btn {
    width: 80px;
    text-align: center;
    height: 40px;
    color: white;
    line-height: 36px;
    img {
      width: 20px;
    }
    &--see {
      background-color: $color2;
    }
    &--add {
      background-color: $color3;
    }
  }
}

@media screen and (max-width: 435px) {
  .product {
    flex-direction: column;
    height: auto;
  }
  .product__info-container {
    width: 100%;
    height: 150px;
  }
  .product__image-container {
    width: 100%;
    height: 150px;
  }
  .product__stock-container {
    display: flex;
    flex-direction: row;
    padding: 0 15px;
    align-items: center;
    height: 58px;
    .stock__text {
      margin-bottom: 0;
      width: 100px;
    }
    .product__stock {
      height: 100%;
      flex: 1;
    }
  }
}
// @media screen and (max-width: 370px){
//   .product__info-container{ width: 70%; }
//   .product__image-container{ width: 30%; }
// }
// @media screen and (max-width: 330px){
//   .product__info-container{ width: 75%; }
//   .product__image-container{ width: 25%; }
// }
</style>



// WEBPACK FOOTER //
// src/components/Product/ProductFavorites.vue